import { FunctionComponent, memo } from "react";
import { DetailsFieldTitle, DetailsFieldValue, LoadingCell, None } from "@edgetier/client-components";
import { useAgent } from "hooks-for/agents/use-agent";

import { IProps } from "./interaction-details-agent.types";
import "./interaction-details-agent.scss";

/**
 * Details about the agent
 * @param props.agentId The ID of the agent who handled the interaction.
 */
const InteractionDetailsAgent: FunctionComponent<IProps> = ({ agentId }) => {
    const { data: agent, isLoading } = useAgent(agentId ?? "", { enabled: agentId !== null });
    return (
        <tr>
            <td>
                <DetailsFieldTitle>Agent Name</DetailsFieldTitle>
            </td>
            <td>
                {isLoading ? (
                    <LoadingCell />
                ) : (
                    <DetailsFieldValue copyText={agent?.name}>
                        {typeof agent !== "undefined" ? agent.name : <None />}
                    </DetailsFieldValue>
                )}
            </td>
        </tr>
    );
};

export default memo(InteractionDetailsAgent);
